import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { getTplUsages } from '@/api/dashboard/playturbo.js';
import { testList } from '@/views/producer/common-template/selling-strategy.js';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { cookRequestParams } from '@/common/request';
import tableMixin from './table-mixin';

var dayTime = 1000 * 60 * 60 * 24;

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date() - dayTime * 30, 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')], // 时间
  adv_ids: [],
  adv_id: '',
  adv_search_type: 'adv_name',
  tpl_mod: '',
  template_id: '',
  template_name: '',
  keyword: '',
  export: 0,
  is_test: '',
  order: '-project_cnt' // 排序
};

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var self = this;
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择前180天的日期
              disabledDate: function disabledDate(time) {
                var curDate = new Date().getTime();
                var threeMonths = curDate - 180 * 24 * 3600 * 1000;
                return time.getTime() > Date.now() || time.getTime() < threeMonths;
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
              /* eslint-enable no-mixed-operators */
            }
          }
        },
        tpl_mod: {
          prop: 'tpl_mod',
          type: 'select',
          params: {
            clearable: true,
            placeholder: '模块',
            options: self.sourceList
          }
        },
        adv_search_type: {
          type: 'select',
          prop: 'adv_search_type',
          params: {
            options: [{
              label: '广告主名称',
              value: 'adv_name'
            }, {
              label: '广告主ID',
              value: 'adv_id'
            }]
          }
        },
        adv_ids: {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select'
          }
        },
        adv_id: {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        template_id: {
          type: 'input',
          prop: 'template_id',
          params: {
            clearable: true,
            placeholder: '请输入模板ID'
          }
        },
        template_name: {
          type: 'input',
          prop: 'template_name',
          params: {
            clearable: true,
            placeholder: '请输入模板名称'
          }
        },
        is_test: {
          prop: 'is_test',
          type: 'select',
          params: {
            placeholder: '是否测试账号',
            clearable: true,
            options: testList
          }
        }
      };
      if (this.query.adv_search_type === 'adv_name') {
        delete list.adv_id;
      } else {
        delete list.adv_ids;
      }

      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      var self = this;
      var tableList = [{
        label: '模块',
        prop: 'tpl_mod',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            var temp = self.sourceList.find(function (item) {
              return item.value === row.tpl_mod;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '广告主ID',
        prop: 'adv_id',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return row.adv_id || '-';
          }
        }
      }, {
        label: '广告主名称',
        prop: 'adv_name',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return row.adv_name || '-';
          }
        }
      }, {
        label: '是否测试账号',
        prop: 'is_test',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            var temp = testList.find(function (s) {
              return s.value === row.is_test;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '订阅类型',
        prop: 'plan_grant_type',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            var temp = self.grantTypeList.find(function (item) {
              return item.value === row.plan_grant_type;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '套餐名称',
        prop: 'plan_name'
      }, {
        label: '授权状态',
        prop: 'status',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            var temp = self.statusList[row.status];
            return temp || '-';
          }
        }
      }, {
        label: '订阅授权渠道',
        prop: 'channel_ids',
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            if (row.channel_ids === '') {
              return 'All';
            } else if (row.channel_ids) {
              return self.getChannelLabel(row.channel_ids);
            }
            return '-';
          }
        }
      }, {
        label: '版本制作方',
        prop: 'create_from',
        params: {
          innerHTML: function innerHTML(_ref8) {
            var row = _ref8.row;

            var temp = self.creatFromList.find(function (item) {
              return item.value === row.create_from;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '模板ID',
        prop: 'template_id'
      }, {
        label: '模板名称',
        prop: 'template_name'
      }, {
        label: '模板玩法',
        prop: 'play_methods',
        params: {
          innerHTML: function innerHTML(_ref9) {
            var row = _ref9.row;

            return row.play_methods || '-';
          }
        }
      }, {
        label: '创建/使用版本个数汇总',
        prop: 'project_cnt'
      }, {
        label: '总推送次数',
        prop: 'push_cnt'
      }, {
        label: '推送ss客户',
        prop: 'target_adv_names'
      }, {
        label: '总下载次数',
        prop: 'download_cnt'
      }, {
        label: '总扣减次数',
        prop: 'reduce_cnt'
      }, {
        label: '下载/推送渠道',
        prop: 'use_channel_ids',
        params: {
          innerHTML: function innerHTML(_ref10) {
            var row = _ref10.row;

            if (row.use_channel_ids) {
              return self.getChannelLabel(row.use_channel_ids);
            }
            return '-';
          }
        }
      }, {
        label: 'Mintegral下载次数',
        prop: 'mintegral_cnt'
      }, {
        label: 'Mintegral推送次数',
        prop: 'mintegral_push_cnt'
      }, {
        label: 'Facebook下载次数',
        prop: 'facebook_cnt'
      }, {
        label: 'Google下载次数',
        prop: 'google_cnt'
      }, {
        label: 'Applovin下载次数',
        prop: 'applovin_cnt'
      }, {
        label: 'Ironsource下载次数',
        prop: 'ironsource_cnt'
      }, {
        label: '巨量引擎下载次数',
        prop: 'ocean_engine_cnt'
      }, {
        label: 'Pangle下载次数',
        prop: 'pangle_cnt'
      }, {
        label: 'Vungle下载次数',
        prop: 'vungle_cnt'
      }, {
        label: '快手下载次数',
        prop: 'ks_cnt'
      }, {
        label: 'Kwai下载次数',
        prop: 'kwai_cnt'
      }, {
        label: '腾讯AMS下载次数',
        prop: 'ams_cnt'
      }, {
        label: '腾讯广告下载次数',
        prop: 'gdt_cnt'
      }, {
        label: 'Adcolony下载次数',
        prop: 'adcolony_cnt'
      }, {
        label: '其他渠道下载次数',
        prop: 'other_cnt'
      }];

      tableList.forEach(function (item) {
        if (_this.notAllowSortColumn.indexOf(item.prop) === -1) {
          item.sortable = 'custom';
        }
        if (_this.dataFormat.indexOf(item.prop) > -1) {
          item.dataFormat = { thousandsSeparator: true };
        }
        item.width = 100;
      });

      return tableList;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    },
    'query.adv_search_type': function queryAdv_search_type(val) {
      if (val === 'adv_name') {
        this.query.adv_id = '';
      } else {
        this.query.adv_ids = [];
      }
    },
    'query.group_by': function queryGroup_by(val) {
      this.query.page = 1;
      // this.handleColumnFilterChange()
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      downloadWithNewWindow(v2Host + '/dashboard/playturbo/tpl-usages?' + qs.stringify(_extends({}, cookRequestParams(_extends({}, this.query, {
        adv_ids: this.query.adv_search_type === 'adv_name' ? this.query.adv_ids : [this.query.adv_id],
        export: 1
      })))));
    },
    handleSortChange: function handleSortChange(_ref11) {
      var column = _ref11.column,
          prop = _ref11.prop,
          order = _ref11.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var innerParams, res, temp, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.listLoading = true;
                _context.prev = 1;
                innerParams = _.cloneDeep(params || _this2.query);
                _context.next = 5;
                return getTplUsages(_extends({}, innerParams, {
                  adv_ids: _this2.query.adv_search_type === 'adv_name' ? _this2.query.adv_ids : [_this2.query.adv_id]
                }));

              case 5:
                res = _context.sent;

                _this2.visibleColumn = _this2.query.group_by;
                temp = _extends({
                  adv_id: 'sum',
                  adv_name: '-',
                  tpl_id: '-',
                  tpl_name: '-',
                  source: '-'
                }, _.get(res, 'data.data.sum'), {
                  template_id: '',
                  channel_ids: '-'
                });
                sum = _.get(res, 'data.data.sum') ? [temp] : [];
                list = sum.concat(_.get(res, 'data.data.list') || []);
                // 处理表格数据

                list.forEach(function (item) {
                  if (Number(item.template_id) === 0) {
                    item.template_id = '-';
                  }
                });
                _this2.list = list;
                _this2.pagination.total = _.get(res, 'data.data.total') || 0;
                _this2.listLoading = false;
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](1);

                _this2.listLoading = false;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 16]]);
      }))();
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.handleResetSearch();
    }
  }
};